<template>
  <v-sheet class="info-block pa-2" rounded="lg" color="grey-lighten-2" v-if="doc" style="position: absolute" width="600">
    <v-btn style="position: absolute; top: 2px; right: 2px;" v-on:click="doc = null" :icon="true" elevation="0" density="compact" color="grey-lighten-2">
      <v-icon :icon="['fas', 'xmark']" />
    </v-btn>
    <v-row>
      <v-col cols="4">
        <v-sheet color="white" rounded>
          <p class="font-weight-bold px-2 text-center">
            <span v-if="doc.doc_type === 'Обращение'">Обращение</span>
            <span v-if="doc.doc_type === 'Проведение ТО и ППР'">Заказ-наряд</span>
            <span><br>№{{ doc.number }}</span>
          </p>

          <v-chip v-if="doc.priority_name" class="mb-3" style="width: 100%" rounded="0" :color="color_of_chip(doc.priority_name)" density="compact">{{ doc.priority_name }}</v-chip>

          <p class="px-2">
            {{ moment(doc.date.create).format('DD.MM.YYYY HH:mm:ss') }}
          </p>
          <p class="px-2">
            <span style="opacity: 0.5; font-size: 12px;">{{ doc.duration }} ч/ч</span>
          </p>
        </v-sheet>
      </v-col>
      <v-col>
        <v-sheet color="white" height="100%" rounded>
          <v-sheet color="transparent" class="pa-2 text-center" style="line-height: 1">
            {{ doc.object.name }}
            <span v-if="doc.location" style="opacity: 0.6;"><br>{{ doc.location.name }}</span>
          </v-sheet>
          <v-chip class="mb-3" style="width: 100%" rounded="0" :color="get_status_color(doc.status.name)" density="compact">{{ doc.status.name }}</v-chip>
          <v-sheet color="transparent" class="pa-2">
            {{ doc.description }}
          </v-sheet>
        </v-sheet>

      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import { MiniInfoBlock } from "@/store/wp_planner/info.store";
import moment from "moment";
import { get_status_color } from "@/libs/utils";

export default {
  name: "MiniInfo__WP_Widget",
  methods: {
    moment,
    get_status_color,
    color_of_chip: function (type) {
      switch (type) {
        case 'Стандартный': return 'green'
        case 'Низкий': return 'grey'
        case 'Высокий (критичный)': return 'red'
        default: return 'black'
      }
    }
  },
  computed: {
    doc: {
      get() {
        return MiniInfoBlock().get()
      },
      set(value) {
        MiniInfoBlock().set(value)
      }
    },
  }
}
</script>

<style scoped>

</style>
